import { GraphQLInputObjectType, GraphQLNonNull } from 'graphql'
import {
  vulnerabilityOrderFieldType,
  VulnerabilityOrderField
} from './vulnerability-order-field'
import { orderDirection, OrderDirection } from './order-direction'

export interface VulnerabilityOrder {
  readonly field: VulnerabilityOrderField
  readonly direction: OrderDirection
}

export const vulnerabilityOrderType = new GraphQLInputObjectType({
  name: 'VulnerabilityOrder',
  description: 'Ways in which a list of vulnerabilities can be ordered',
  fields: () => ({
    field: {
      description: 'The field to order the results by',
      type: new GraphQLNonNull(vulnerabilityOrderFieldType)
    },
    direction: {
      description: 'The direction in which to order the results',
      type: new GraphQLNonNull(orderDirection)
    }
  })
})
